import styled from '@emotion/styled'

import { Color } from '../../enums/color'
import { ComponentsGroup } from '../ComponentsGroup'

export const TabsGroup = styled(ComponentsGroup)`
  align-items: center;
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 ${Color.Grey200};
  overflow: hidden;
`
